
( ( $ ) => {

	if ( $( ".phr-block--resources-carousel" ).length > 0 )
	{
		$( ".phr-block--resources-carousel" ).slick( {
			slidesToShow: 1,
			dots: true,
			arrows: false,
			infinite: false
		} );
	}

} )( jQuery );